import { default as indexE4q7643y4zMeta } from "/home/jetmix/production/storebusters-landing/pages/401/index.vue?macro=true";
import { default as indexoHUP5vdG1mMeta } from "/home/jetmix/production/storebusters-landing/pages/contacts/index.vue?macro=true";
import { default as indexWf2o7Io42MMeta } from "/home/jetmix/production/storebusters-landing/pages/delivery-terms/index.vue?macro=true";
import { default as indexjLjOtv4jRNMeta } from "/home/jetmix/production/storebusters-landing/pages/index.vue?macro=true";
import { default as indexjLIHHn7GeHMeta } from "/home/jetmix/production/storebusters-landing/pages/limitations/index.vue?macro=true";
import { default as indexbs8pBEZ4wFMeta } from "/home/jetmix/production/storebusters-landing/pages/limits/index.vue?macro=true";
import { default as indexqclCnMq4JjMeta } from "/home/jetmix/production/storebusters-landing/pages/payment-methods/index.vue?macro=true";
import { default as failtsYit8sBuGMeta } from "/home/jetmix/production/storebusters-landing/pages/payment/callback/fail.vue?macro=true";
import { default as successyaUfovNun4Meta } from "/home/jetmix/production/storebusters-landing/pages/payment/callback/success.vue?macro=true";
import { default as failpjZgSq0LkgMeta } from "/home/jetmix/production/storebusters-landing/pages/payment/fail.vue?macro=true";
import { default as indexF4OWzxA4SzMeta } from "/home/jetmix/production/storebusters-landing/pages/payment/index.vue?macro=true";
import { default as successM43LHQL3sRMeta } from "/home/jetmix/production/storebusters-landing/pages/payment/success.vue?macro=true";
import { default as indexb4YrnNRh1XMeta } from "/home/jetmix/production/storebusters-landing/pages/shipping-calculator/Backup/index.vue?macro=true";
import { default as indexEY2vWgmQ3PMeta } from "/home/jetmix/production/storebusters-landing/pages/shipping-calculator/index.vue?macro=true";
import { default as _91id_93rQgX69SkOmMeta } from "/home/jetmix/production/storebusters-landing/pages/shops/[id].vue?macro=true";
import { default as index4OGJ5j0fmIMeta } from "/home/jetmix/production/storebusters-landing/pages/shops/index.vue?macro=true";
import { default as indexqkj9BtVbb0Meta } from "/home/jetmix/production/storebusters-landing/pages/techworks/index.vue?macro=true";
import { default as index0q53x95cSYMeta } from "/home/jetmix/production/storebusters-landing/pages/terms/index.vue?macro=true";
import { default as privacyt3jpSwop6kMeta } from "/home/jetmix/production/storebusters-landing/pages/terms/privacy.vue?macro=true";
export default [
  {
    name: indexE4q7643y4zMeta?.name ?? "401",
    path: indexE4q7643y4zMeta?.path ?? "/401",
    meta: indexE4q7643y4zMeta || {},
    alias: indexE4q7643y4zMeta?.alias || [],
    redirect: indexE4q7643y4zMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/401/index.vue").then(m => m.default || m)
  },
  {
    name: indexoHUP5vdG1mMeta?.name ?? "contacts",
    path: indexoHUP5vdG1mMeta?.path ?? "/contacts",
    meta: indexoHUP5vdG1mMeta || {},
    alias: indexoHUP5vdG1mMeta?.alias || [],
    redirect: indexoHUP5vdG1mMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: indexWf2o7Io42MMeta?.name ?? "delivery-terms",
    path: indexWf2o7Io42MMeta?.path ?? "/delivery-terms",
    meta: indexWf2o7Io42MMeta || {},
    alias: indexWf2o7Io42MMeta?.alias || [],
    redirect: indexWf2o7Io42MMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/delivery-terms/index.vue").then(m => m.default || m)
  },
  {
    name: indexjLjOtv4jRNMeta?.name ?? "index",
    path: indexjLjOtv4jRNMeta?.path ?? "/",
    meta: indexjLjOtv4jRNMeta || {},
    alias: indexjLjOtv4jRNMeta?.alias || [],
    redirect: indexjLjOtv4jRNMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexjLIHHn7GeHMeta?.name ?? "limitations",
    path: indexjLIHHn7GeHMeta?.path ?? "/limitations",
    meta: indexjLIHHn7GeHMeta || {},
    alias: indexjLIHHn7GeHMeta?.alias || [],
    redirect: indexjLIHHn7GeHMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/limitations/index.vue").then(m => m.default || m)
  },
  {
    name: indexbs8pBEZ4wFMeta?.name ?? "limits",
    path: indexbs8pBEZ4wFMeta?.path ?? "/limits",
    meta: indexbs8pBEZ4wFMeta || {},
    alias: indexbs8pBEZ4wFMeta?.alias || [],
    redirect: indexbs8pBEZ4wFMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/limits/index.vue").then(m => m.default || m)
  },
  {
    name: indexqclCnMq4JjMeta?.name ?? "payment-methods",
    path: indexqclCnMq4JjMeta?.path ?? "/payment-methods",
    meta: indexqclCnMq4JjMeta || {},
    alias: indexqclCnMq4JjMeta?.alias || [],
    redirect: indexqclCnMq4JjMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/payment-methods/index.vue").then(m => m.default || m)
  },
  {
    name: failtsYit8sBuGMeta?.name ?? "payment-callback-fail",
    path: failtsYit8sBuGMeta?.path ?? "/payment/callback/fail",
    meta: failtsYit8sBuGMeta || {},
    alias: failtsYit8sBuGMeta?.alias || [],
    redirect: failtsYit8sBuGMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/payment/callback/fail.vue").then(m => m.default || m)
  },
  {
    name: successyaUfovNun4Meta?.name ?? "payment-callback-success",
    path: successyaUfovNun4Meta?.path ?? "/payment/callback/success",
    meta: successyaUfovNun4Meta || {},
    alias: successyaUfovNun4Meta?.alias || [],
    redirect: successyaUfovNun4Meta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/payment/callback/success.vue").then(m => m.default || m)
  },
  {
    name: failpjZgSq0LkgMeta?.name ?? "payment-fail",
    path: failpjZgSq0LkgMeta?.path ?? "/payment/fail",
    meta: failpjZgSq0LkgMeta || {},
    alias: failpjZgSq0LkgMeta?.alias || [],
    redirect: failpjZgSq0LkgMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/payment/fail.vue").then(m => m.default || m)
  },
  {
    name: indexF4OWzxA4SzMeta?.name ?? "payment",
    path: indexF4OWzxA4SzMeta?.path ?? "/payment",
    meta: indexF4OWzxA4SzMeta || {},
    alias: indexF4OWzxA4SzMeta?.alias || [],
    redirect: indexF4OWzxA4SzMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/payment/index.vue").then(m => m.default || m)
  },
  {
    name: successM43LHQL3sRMeta?.name ?? "payment-success",
    path: successM43LHQL3sRMeta?.path ?? "/payment/success",
    meta: successM43LHQL3sRMeta || {},
    alias: successM43LHQL3sRMeta?.alias || [],
    redirect: successM43LHQL3sRMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/payment/success.vue").then(m => m.default || m)
  },
  {
    name: indexb4YrnNRh1XMeta?.name ?? "shipping-calculator-Backup",
    path: indexb4YrnNRh1XMeta?.path ?? "/shipping-calculator/Backup",
    meta: indexb4YrnNRh1XMeta || {},
    alias: indexb4YrnNRh1XMeta?.alias || [],
    redirect: indexb4YrnNRh1XMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/shipping-calculator/Backup/index.vue").then(m => m.default || m)
  },
  {
    name: indexEY2vWgmQ3PMeta?.name ?? "shipping-calculator",
    path: indexEY2vWgmQ3PMeta?.path ?? "/shipping-calculator",
    meta: indexEY2vWgmQ3PMeta || {},
    alias: indexEY2vWgmQ3PMeta?.alias || [],
    redirect: indexEY2vWgmQ3PMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/shipping-calculator/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93rQgX69SkOmMeta?.name ?? "shops-id",
    path: _91id_93rQgX69SkOmMeta?.path ?? "/shops/:id()",
    meta: _91id_93rQgX69SkOmMeta || {},
    alias: _91id_93rQgX69SkOmMeta?.alias || [],
    redirect: _91id_93rQgX69SkOmMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/shops/[id].vue").then(m => m.default || m)
  },
  {
    name: index4OGJ5j0fmIMeta?.name ?? "shops",
    path: index4OGJ5j0fmIMeta?.path ?? "/shops",
    meta: index4OGJ5j0fmIMeta || {},
    alias: index4OGJ5j0fmIMeta?.alias || [],
    redirect: index4OGJ5j0fmIMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/shops/index.vue").then(m => m.default || m)
  },
  {
    name: indexqkj9BtVbb0Meta?.name ?? "techworks",
    path: indexqkj9BtVbb0Meta?.path ?? "/techworks",
    meta: indexqkj9BtVbb0Meta || {},
    alias: indexqkj9BtVbb0Meta?.alias || [],
    redirect: indexqkj9BtVbb0Meta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/techworks/index.vue").then(m => m.default || m)
  },
  {
    name: index0q53x95cSYMeta?.name ?? "terms",
    path: index0q53x95cSYMeta?.path ?? "/terms",
    meta: index0q53x95cSYMeta || {},
    alias: index0q53x95cSYMeta?.alias || [],
    redirect: index0q53x95cSYMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: privacyt3jpSwop6kMeta?.name ?? "terms-privacy",
    path: privacyt3jpSwop6kMeta?.path ?? "/terms/privacy",
    meta: privacyt3jpSwop6kMeta || {},
    alias: privacyt3jpSwop6kMeta?.alias || [],
    redirect: privacyt3jpSwop6kMeta?.redirect || undefined,
    component: () => import("/home/jetmix/production/storebusters-landing/pages/terms/privacy.vue").then(m => m.default || m)
  }
]